import React from 'react'
import { Box } from "@mui/material"
import { AppFilterChip } from "@components"
import { useSignal } from "@preact/signals-react"


export default function AlertsTableCustomToolbar({ legendElements, filterConditions, isNoAvailability }) {
	return (
		<Box data-tour-id="tour-alert-legend" sx={{
			...isNoAvailability && { visibility: "hidden" },
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			flexDirection: "column",
			mb: 1
		}}>
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", flexWrap: "wrap", gap: 1 }}>
				{!!legendElements.length && legendElements.map(({ icon, value, label, iconProps = {} }, idx) => {
					const selected = useSignal(false)
					// an item with no value only explains an icon (Rating Score): it shows, it does not filter
					return <AppFilterChip
						key={idx}
						icon={icon}
						iconSx={iconProps}
						label={label}
						selected={selected.value}
						disabled={value === undefined}
						onClick={() => {
							filterConditions(value)
							selected.value = !selected.value
						}}
						sx={value === undefined ? { '&.Mui-disabled': { opacity: 1 } } : {}}
					/>
				})}
			</Box>
		</Box>
	)
}
